import React from "react"
import "./ToggleButton.css"

export default function ToggleButton(props) {
    return (
    <>
    <p style={{margin: '0px 10px'}}>{props.revealed ? 'Desaturate' : 'Saturate'}</p>
    <label className="switch">
      <input type="checkbox" onClick={props.onClick} onKeyPress={props.onClick} className="device-toggle-switch" />
      <span className="slider round"></span>
    </label>
    </>
    )
}